var exports = {
  "Y2": "FriendListItem.module__friendListItem___UUg0Q1",
  "lY": "FriendListItem.module__contextMenuActive___UUg0Q1",
  "Hb": "FriendListItem.module__friendInfo___UUg0Q1",
  "HX": "FriendListItem.module__friendDetails___UUg0Q1",
  "Um": "FriendListItem.module__friendNameRow___UUg0Q1",
  "G3": "FriendListItem.module__friendName___UUg0Q1",
  "tf": "FriendListItem.module__friendTag___UUg0Q1",
  "kC": "FriendListItem.module__friendSubtext___UUg0Q1",
  "MI": "FriendListItem.module__friendStatusOffline___UUg0Q1",
  "wh": "FriendListItem.module__friendStatusOnline___UUg0Q1",
  "yA": "FriendListItem.module__friendActions___UUg0Q1",
  "I0": "FriendListItem.module__actionButtonMessage___UUg0Q1",
  "cQ": "FriendListItem.module__actionButtonMore___UUg0Q1",
  "nl": "FriendListItem.module__contextMenuButtonActive___UUg0Q1",
  "TI": "FriendListItem.module__actionButtonAccept___UUg0Q1",
  "Tl": "FriendListItem.module__actionButtonIgnore___UUg0Q1",
  "P7": "FriendListItem.module__actionButtonCancel___UUg0Q1",
  "RK": "FriendListItem.module__iconSize___UUg0Q1",
};

module.exports = exports;
